import React, { useCallback, useEffect, useState } from "react";
import IconTextButton from "../../../repertoire/components/iconTextButton/IconTextButton";
import { IValidationMessage } from "../../../repertoire/types/IValidationMessage";
import { IRepertoireField } from "../../../repertoire/types/IRepertoireField";
import { IMyPackagesResult } from "../../../repertoire/types/IMyPackagesResult";
import { useAddToPackageContext } from "./AddToPackageContext";
import { CURRENT_USER_EMAIL_KEY } from "../../../redux/services/AccountSessionStorage";

interface AddToPackageButtonProps {
    workID: number;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => IMyPackagesResult;
    searchResultsTableData: IRepertoireField[];
    entityType: any;
    disabled?: boolean;
}

const AddToPackageButton: React.FC<AddToPackageButtonProps> = ({
    workID,
    addToPackages,
    searchResultsTableData,
    entityType,
    disabled = false
}) => {
    const [added, setAdded] = useState(false);
    const [messageText, setMessageText] = useState("");
    const [messageType, setMessageType] = useState<"success" | "error" | undefined>(undefined);
    const { addedIds, addIds } = useAddToPackageContext();
    const messageClass =
        messageType === "error"
            ? "addtopackageerrorMessage"
            : "addtopackagesuccessMessage";

    useEffect(() => {
        setAdded(addedIds.includes(workID));
    }, [addedIds, workID]);

    const handleAddToPackages = useCallback(async () => {
        if (disabled || !addToPackages) {
            return;
        }
        const username = sessionStorage.getItem(CURRENT_USER_EMAIL_KEY);
        const response = await addToPackages(username, entityType, [workID]);
        
        const messageKey =
            response?.messages?.[0]?.messageKey;

        const configuredMessage =
            searchResultsTableData.find(
                field =>
                    field.name?.toString() === messageKey
            )?.data;

        const displayMessage =
            configuredMessage ||
            (response?.success
                ? "Added to package"
                : "Could not add to package");

        setMessageText(displayMessage);

        if (response && response.success) {
            addIds([workID]);
            setAdded(true);
            setMessageType("success");
        } else {
            setMessageType("error");
        }

        setTimeout(() => {
            setMessageText('');
        }, 2000);
    }, [addToPackages, entityType, workID, searchResultsTableData, addIds, disabled]);

    const isDisabled = disabled || added;

    return (
        <div
            className="tableCell specialColumn"
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
            <div>
                {messageText && (
                    <div className={`messageBox ${messageClass}`}>{messageText}</div>
                )}

                <div className="workAddtoPackage addToPackageButton">
                    <IconTextButton
                        icon={added ? "icon ms-Icon ms-Icon--CheckMark" : "icon ms-Icon ms-Icon--AddIn"}
                        onClick={handleAddToPackages}
                        disabled={isDisabled}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddToPackageButton;